import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex-initial flex align-items-center justify-content-center m-2" }
const _hoisted_3 = { class: "flex-initial flex align-items-center justify-content-center m-2" }
const _hoisted_4 = ["textContent"]

import { computed, onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import { useDeepClone, usePersonTypes } from '@/composables';
import { PersonStores } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileNotifications',
  setup(__props) {

const toast = useToast();

const profileStore = PersonStores.useUserProfileStore();
const { notifications } = storeToRefs(profileStore);

const cloned = ref();

const dirty = ref(false);

const shouldDisplay = computed<boolean>(() => usePersonTypes.isParent() || usePersonTypes.isStudent());

const payload = computed(() => notifications.value.data.filter((item) => item.status).map((item) => item.id));

onMounted(async () => (await profileStore.getNotifications(), defineCloned()));

const defineCloned = () => (cloned.value = useDeepClone(notifications.value.data));

const onCancel = () => {
  notifications.value.data = useDeepClone(cloned.value);
  dirty.value = false;
};

const onSave = () => {
  profileStore.syncNotifications(payload.value);
  defineCloned();
  toast.add({
    severity: 'success',
    summary: 'Saved',
    detail: 'Notifications have been saved',
    life: 3000,
  });
  dirty.value = false;
};

const onStatus = () => (dirty.value = true);

return (_ctx: any,_cache: any) => {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_FormCard = _resolveComponent("FormCard")!

  return (shouldDisplay.value)
    ? (_openBlock(), _createBlock(_component_FormCard, {
        key: 0,
        title: "Notifications",
        dirty: dirty.value,
        cancel: onCancel,
        save: onSave
      }, {
        form: _withCtx(() => [
          _createElementVNode("form", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications).data, (item, key) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: "flex"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_InputSwitch, {
                    modelValue: item.status,
                    "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                    onInput: onStatus
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", {
                    textContent: _toDisplayString(item.title)
                  }, null, 8, _hoisted_4)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["dirty"]))
    : _createCommentVNode("", true)
}
}

})